/**
  * WebFont Loader
  * @desc Make sure all typo in the page not show blank while the site is loading
  */
WebFont.load({
  google: {
    families: [
      'Roboto Condensed:300,300i,400,400i,700,700i',
      'Sarabun:300,300i,400,400i,700,700i'
    ]
  }
});